import React from 'react';

export const Footer: React.FC = () => (
  <footer className="border-t border-zinc-800 bg-zinc-950 py-8 px-10 w-full mt-auto">
     <div className="max-w-5xl mx-auto flex justify-between items-center text-xs text-zinc-600">
        <div className="flex gap-6">
           <a href="#" className="hover:text-zinc-400">Terms</a>
           <a href="#" className="hover:text-zinc-400">Privacy</a>
           <a href="#" className="hover:text-zinc-400">Docs</a>
           <a href="#" className="hover:text-zinc-400">Status</a>
        </div>
        <div>
           &copy; 2024 EZ Studio Inc.
        </div>
     </div>
  </footer>
);